import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { SUB_ACCOUNTS_API } from '../api/sub-accounts-api';
import { SubAccountCreateInterface, SubAccountEditInterface, SubAccountInterface } from '../types/sub-account-interface';
export const useSubAccountsActions = () => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: createFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.put
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: editFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.delete
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t2);
  let t3;
  if ($[3] !== createFetcher) {
    t3 = data => createFetcher(SUB_ACCOUNTS_API, data);
    $[3] = createFetcher;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const createSubAccount = t3;
  let t4;
  if ($[5] !== editFetcher) {
    t4 = (id, data_0) => editFetcher(`${SUB_ACCOUNTS_API}/${id}`, data_0);
    $[5] = editFetcher;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const editSubAccount = t4;
  let t5;
  if ($[7] !== deleteFetcher) {
    t5 = id_0 => deleteFetcher(`${SUB_ACCOUNTS_API}/${id_0}`);
    $[7] = deleteFetcher;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const deleteSubAccount = t5;
  let t6;
  if ($[9] !== createSubAccount || $[10] !== deleteSubAccount || $[11] !== editSubAccount) {
    t6 = {
      createSubAccount,
      editSubAccount,
      deleteSubAccount
    };
    $[9] = createSubAccount;
    $[10] = deleteSubAccount;
    $[11] = editSubAccount;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};